import { useForm } from "@tanstack/react-form";
import { useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { Button, Input, Label, ValidationMessage } from "components/elements";
import { FormCard } from "components/form/LoginRegistrationForm";
import { tokenManager } from "lib/tokenManager";
import { RegisterUser, RegisterUserSchema } from "@compass/shared/types";
import { API_BASE } from "../config";

export const Register = () => {
    const navigate = useNavigate();

    const [disabled, setDisabled] = useState(false);
    const [error, setError] = useState<string | false>(false);

    const form = useForm({
        defaultValues: {
            name: "",
            email: "",
            password: "",
            code: "",
        },
        validators: {
            onSubmit: RegisterUserSchema,
        },
        onSubmit: async ({ value }) => {
            setDisabled(true);

            try {
                const response = await fetch(`${API_BASE}/register`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(value),
                });

                if (response.status === 200) {
                    const { token } = await response.json();
                    localStorage.setItem("token", token);
                    tokenManager.set(token);
                    navigate({ to: "/" });

                    return;
                } else if (response.status === 500 || response.status === 401) {
                    const { message } = await response.json();
                    setError(message);
                    setDisabled(false);
                } else {
                    setDisabled(false);
                }
            } catch (e) {
                console.error(e);
                setDisabled(false);
            }
        },
    });

    return (
        <FormCard
            title="Register"
            onSubmit={(e) => {
                e.preventDefault();
                e.stopPropagation();
                form.handleSubmit();
            }}
        >
            <form.Field name="name">
                {(field) => (
                    <>
                        <Label htmlFor="name">Name</Label>
                        <Input
                            name={field.name}
                            value={field.state.value}
                            onChange={(e) => field.handleChange(e.target.value)}
                            onBlur={field.handleBlur}
                            disabled={disabled}
                            type="text"
                            id="name"
                            className="w-full"
                        />
                        <ValidationMessage error={field.state.meta.errors[0]?.message} />
                    </>
                )}
            </form.Field>

            <form.Field name="email">
                {(field) => (
                    <>
                        <Label htmlFor="email">Email</Label>
                        <Input
                            name={field.name}
                            value={field.state.value}
                            onChange={(e) => field.handleChange(e.target.value)}
                            onBlur={field.handleBlur}
                            disabled={disabled}
                            id="email"
                            placeholder="user@example.com"
                            className="w-full"
                        />
                        <ValidationMessage error={field.state.meta.errors[0]?.message} />
                    </>
                )}
            </form.Field>

            <form.Field name="password">
                {(field) => (
                    <>
                        <Label htmlFor="password">Password</Label>
                        <Input
                            name={field.name}
                            value={field.state.value}
                            onChange={(e) => field.handleChange(e.target.value)}
                            onBlur={field.handleBlur}
                            disabled={disabled}
                            type="password"
                            className="w-full"
                        />
                        <ValidationMessage error={field.state.meta.errors[0]?.message} />
                    </>
                )}
            </form.Field>

            <form.Field name="code">
                {(field) => (
                    <>
                        <Label htmlFor="code">Registration Code</Label>
                        <Input
                            name={field.name}
                            value={field.state.value}
                            onChange={(e) => field.handleChange(e.target.value)}
                            onBlur={field.handleBlur}
                            disabled={disabled}
                            type="code"
                            className="w-full"
                        />
                        <ValidationMessage error={field.state.meta.errors[0]?.message} />
                    </>
                )}
            </form.Field>

            <div className="h-2" />
            {error && <div className="pb-2 text-red-500">{error}</div>}
            <button type="submit" disabled={disabled}>
                <Button>Register</Button>
            </button>
        </FormCard>
    );
};
